export default {
    onKeyPress: function () {
        this.element.find('.nav-tabs').on('keydown', '.nav-link ', (e) => {
                this.triggerKeyPressEvent(e);
        })
    }
}